import {getRegion } from "sr/utils/api/city/getGeofenceCity";

interface typeParams {
    setLoader?:(params:any)=> void
    setData:(params:any)=> void
 }
export const fetchRegion = async (params:typeParams) => {
  if (params?.setLoader) params?.setLoader(true)
    try {
const res = await getRegion()
if(res?.success===true){
    params?.setData(res?.data)
  if (params?.setLoader)   params?.setLoader(false)
}

}
catch(e){

}
};
